import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as authAction from '@app/views/common/auth.actions';
import * as IntegrationActions from '@app/core/reducers/integration/integration.actions';
import {select, Store} from '@ngrx/store';
import {State} from '@app/views/common/auth.reducers';
import {filter, take, takeWhile} from 'rxjs/operators';
import {getAuthenticatedUser} from '@app/app.reducers';
import {User} from '@app/core/model/user';
import {Subscription} from 'rxjs';
import {SplashScreenService} from '@app/core/service/splash-screen.service';
import {CookieService} from 'ngx-cookie-service';
import {TokenService} from '@app/core/security/token.service';

@Component({
    selector: 'ngc-auth-saml',
    templateUrl: './auth-saml.component.html',
    styleUrls: ['./auth-saml.component.scss']
})
export class AuthSamlComponent implements OnInit, OnDestroy {

    private subscriptions: Subscription[] = [];

    constructor(private splashScreen: SplashScreenService,
                private activatedRoute: ActivatedRoute,
                public router: Router,
                private store: Store<State>,
                private cookieService: CookieService,
                private tokenService: TokenService) {
        const token = this.cookieService.get('SESSION');
        if (token) {
            this.splashScreen.setHideOnNavigationEnd(false);

            this.cookieService.delete('SESSION');
            this.tokenService.setToken(token);

            this.store.dispatch(new IntegrationActions.IntegrationClearState());
            this.store.dispatch(new authAction.AuthenticationSuccessAction());
        } else {
            this.router.navigate(['']);
        }

        // Subscribe to success authentication
        this.subscriptions.push(
            this.store.pipe(
                select(getAuthenticatedUser),
                filter(user => !!user)
            ).subscribe((user: User) => {
                // ToDo: Use previousPage from sessionStorage ?
                // if (this.lastVisitedPage && user.username.toLocaleLowerCase() === localStorage.getItem('lastAuthenticatedUser')) {
                //     this.router.navigate([this.lastVisitedPage]);
                // } else {
                //     this.router.navigate([this.returnUrl]);
                // }
                this.splashScreen.setHideOnNavigationEnd(true);
                this.router.navigate(['']);
            })
        );
    }

    ngOnInit(): void {
    }

    public ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
